// Building Materials Database for Custom Building Calculator
// Weights are for DEMOLISHED materials (20% lighter than intact due to air voids)

export const buildingMaterialsDatabase = {
  // EXTERNAL WALL - EXTERIOR FINISH
  exteriorFinish: [
    { name: 'Vinyl Siding', weightPerSqFt: 1.3, description: 'Lightweight vinyl exterior' },
    { name: 'Aluminum Siding', weightPerSqFt: 1.6, description: 'Metal siding' },
    { name: 'Wood Siding (1/2")', weightPerSqFt: 2.6, description: 'Wood clapboard' },
    { name: 'Cedar Shake', weightPerSqFt: 3.1, description: 'Cedar shakes' },
    { name: 'Fiber Cement (5/16")', weightPerSqFt: 2.4, description: 'Hardie board thin' },
    { name: 'Fiber Cement (1/2")', weightPerSqFt: 3.6, description: 'Hardie board thick' },
    { name: 'Stucco (1" Traditional)', weightPerSqFt: 10.4, description: '3-coat stucco' },
    { name: 'Stucco (EIFS)', weightPerSqFt: 3.6, description: 'Synthetic stucco' },
    { name: 'Brick Veneer (4")', weightPerSqFt: 38.0, description: 'Thin brick facing (demolished)' },
    { name: 'Stone Veneer (Cultured)', weightPerSqFt: 12.5, description: 'Manufactured stone' },
    { name: 'Stone Veneer (Natural)', weightPerSqFt: 15.6, description: 'Natural stone' },
    { name: 'Metal Panel', weightPerSqFt: 2.1, description: 'Corrugated metal' },
    { name: 'None', weightPerSqFt: 0, description: 'No exterior finish' }
  ],

  // EXTERNAL WALL - STRUCTURE
  exteriorStructure: [
    { name: 'Wood Frame 2x4 (16" OC)', weightPerSqFt: 2.4, description: 'Standard wood studs' },
    { name: 'Wood Frame 2x6 (16" OC)', weightPerSqFt: 3.6, description: 'Thick wood studs' },
    { name: 'Wood Frame 2x4 (24" OC)', weightPerSqFt: 1.6, description: 'Wide spacing studs' },
    { name: 'Metal Studs (20 gauge)', weightPerSqFt: 2.0, description: 'Light gauge steel' },
    { name: 'Metal Studs (18 gauge)', weightPerSqFt: 2.5, description: 'Heavy gauge steel' },
    { name: '4" Concrete Block', weightPerSqFt: 24.0, description: 'CMU 4 inch (demolished)' },
    { name: '6" Concrete Block', weightPerSqFt: 32.0, description: 'CMU 6 inch (demolished)' },
    { name: '8" Concrete Block', weightPerSqFt: 40.0, description: 'CMU 8 inch (demolished)' },
    { name: '4" Poured Concrete', weightPerSqFt: 41.6, description: 'Solid concrete wall (demolished)' },
    { name: '6" Poured Concrete', weightPerSqFt: 62.4, description: 'Thick concrete wall (demolished)' },
    { name: '8" Poured Concrete', weightPerSqFt: 83.2, description: 'Heavy concrete wall (demolished)' }
  ],

  // EXTERNAL WALL - INSULATION
  insulation: [
    { name: 'None', weightPerSqFt: 0, description: 'No insulation' },
    { name: 'Fiberglass Batt R-13 (3.5")', weightPerSqFt: 0.4, description: 'Standard 2x4 wall' },
    { name: 'Fiberglass Batt R-19 (6")', weightPerSqFt: 0.6, description: 'Standard 2x6 wall' },
    { name: 'Fiberglass Batt R-21 (6")', weightPerSqFt: 0.6, description: 'High-density 2x6' },
    { name: 'Spray Foam (3")', weightPerSqFt: 0.2, description: 'Closed cell foam' },
    { name: 'Spray Foam (5")', weightPerSqFt: 0.4, description: 'Thick closed cell' },
    { name: 'Rigid Foam 1" (R-5)', weightPerSqFt: 0.2, description: 'Foam board' },
    { name: 'Rigid Foam 2" (R-10)', weightPerSqFt: 0.4, description: 'Thick foam board' },
    { name: 'Blown Cellulose (3.5")', weightPerSqFt: 1.0, description: 'Recycled paper' }
  ],

  // EXTERNAL & INTERNAL WALL - INTERIOR FINISH
  interiorFinish: [
    { name: '1/4" Drywall', weightPerSqFt: 1.4, description: 'Thin gypsum board' },
    { name: '3/8" Drywall', weightPerSqFt: 2.0, description: 'Light gypsum board' },
    { name: '1/2" Drywall', weightPerSqFt: 2.6, description: 'Standard gypsum board' },
    { name: '5/8" Drywall', weightPerSqFt: 3.2, description: 'Fire-rated board' },
    { name: 'Plaster (1/2")', weightPerSqFt: 4.0, description: 'Traditional plaster' },
    { name: 'Wood Paneling (1/4")', weightPerSqFt: 1.2, description: 'Decorative paneling' },
    { name: 'Tile (1/4" Ceramic)', weightPerSqFt: 2.6, description: 'Ceramic wall tile' },
    { name: 'Tile (3/8" Porcelain)', weightPerSqFt: 4.2, description: 'Porcelain tile' },
    { name: 'None', weightPerSqFt: 0, description: 'No interior finish' }
  ],

  // INTERIOR WALL - STRUCTURE
  interiorStructure: [
    { name: 'Wood Studs 2x3 (16" OC)', weightPerSqFt: 1.6, description: 'Light wood frame' },
    { name: 'Wood Studs 2x4 (16" OC)', weightPerSqFt: 2.4, description: 'Standard wood frame' },
    { name: 'Wood Studs 2x4 (24" OC)', weightPerSqFt: 1.6, description: 'Wide spacing' },
    { name: 'Metal Studs (25 gauge)', weightPerSqFt: 1.6, description: 'Light steel studs' },
    { name: 'Metal Studs (20 gauge)', weightPerSqFt: 2.0, description: 'Standard steel studs' }
  ],

  // FLOOR MATERIALS
  floor: [
    { name: '4" Concrete Slab', weightPerSqFt: 41.6, description: 'Standard slab (demolished)' },
    { name: '5" Concrete Slab', weightPerSqFt: 52.0, description: 'Thick slab (demolished)' },
    { name: '6" Concrete Slab', weightPerSqFt: 62.4, description: 'Heavy slab (demolished)' },
    { name: '3/4" Plywood Subfloor', weightPerSqFt: 1.8, description: 'Wood subfloor' },
    { name: '3/4" OSB Subfloor', weightPerSqFt: 1.8, description: 'Engineered wood' },
    { name: '3/4" Hardwood', weightPerSqFt: 2.6, description: 'Solid hardwood' },
    { name: 'Ceramic Tile (1/4")', weightPerSqFt: 2.6, description: 'Ceramic floor' },
    { name: 'Porcelain Tile (3/8")', weightPerSqFt: 4.2, description: 'Porcelain floor' },
    { name: 'Vinyl/LVT', weightPerSqFt: 1.6, description: 'Vinyl flooring' },
    { name: 'Carpet + Pad', weightPerSqFt: 1.2, description: 'Carpeting' }
  ],

  // CEILING MATERIALS
  ceiling: [
    { name: '1/2" Drywall', weightPerSqFt: 2.6, description: 'Standard ceiling' },
    { name: '5/8" Drywall (Fire-rated)', weightPerSqFt: 3.2, description: 'Fire-rated ceiling' },
    { name: 'Drop Ceiling (2x4 Tiles)', weightPerSqFt: 1.2, description: 'Suspended ceiling' },
    { name: 'Plaster (1/2")', weightPerSqFt: 4.0, description: 'Plaster ceiling' },
    { name: 'Wood Planks (1/2")', weightPerSqFt: 2.0, description: 'Wood ceiling' },
    { name: 'Acoustic Tiles', weightPerSqFt: 0.8, description: 'Sound-absorbing tiles' },
    { name: 'None (Exposed)', weightPerSqFt: 0, description: 'No ceiling finish' }
  ],

  // CEILING STRUCTURE
  ceilingStructure: [
    { name: 'Wood Joists 2x6 (16" OC)', weightPerSqFt: 2.2, description: 'Standard ceiling joists' },
    { name: 'Wood Joists 2x8 (16" OC)', weightPerSqFt: 3.0, description: 'Heavy ceiling joists' },
    { name: 'Wood Joists 2x10 (16" OC)', weightPerSqFt: 3.8, description: 'Extra heavy joists' },
    { name: 'Steel Joists (Light)', weightPerSqFt: 2.5, description: 'Light steel joists' },
    { name: 'Steel Joists (Heavy)', weightPerSqFt: 3.5, description: 'Heavy steel joists' },
    { name: 'Wood Trusses', weightPerSqFt: 2.0, description: 'Engineered trusses' },
    { name: 'None', weightPerSqFt: 0, description: 'No structure' }
  ],

  // ROOF MATERIALS
  roofCovering: [
    { name: 'Asphalt Shingles (3-tab)', weightPerSqFt: 2.2, description: 'Basic shingles' },
    { name: 'Asphalt Shingles (Architectural)', weightPerSqFt: 3.0, description: 'Dimensional shingles' },
    { name: 'Wood Shakes', weightPerSqFt: 3.2, description: 'Cedar shakes' },
    { name: 'Clay Tile', weightPerSqFt: 9.5, description: 'Clay roof tiles (demolished)' },
    { name: 'Concrete Tile', weightPerSqFt: 11.0, description: 'Concrete roof tiles (demolished)' },
    { name: 'Metal Roofing (Standing Seam)', weightPerSqFt: 1.2, description: 'Metal panels' },
    { name: 'Metal Roofing (Corrugated)', weightPerSqFt: 1.0, description: 'Corrugated metal' },
    { name: 'Slate', weightPerSqFt: 9.0, description: 'Natural slate' },
    { name: 'TPO/EPDM (Flat Roof)', weightPerSqFt: 1.4, description: 'Rubber membrane' },
    { name: 'Built-up Roof (Tar & Gravel)', weightPerSqFt: 4.6, description: 'Flat roof system' }
  ],

  // ROOF STRUCTURE
  roofStructure: [
    { name: 'Wood Trusses (2x4)', weightPerSqFt: 2.0, description: 'Engineered trusses' },
    { name: 'Wood Trusses (2x6)', weightPerSqFt: 2.8, description: 'Heavy trusses' },
    { name: 'Wood Rafters 2x6 (16" OC)', weightPerSqFt: 2.2, description: 'Standard rafters' },
    { name: 'Wood Rafters 2x8 (16" OC)', weightPerSqFt: 3.0, description: 'Heavy rafters' },
    { name: 'Wood Rafters 2x10 (16" OC)', weightPerSqFt: 3.8, description: 'Extra heavy rafters' },
    { name: '1/2" Plywood Sheathing', weightPerSqFt: 1.2, description: 'Roof deck' },
    { name: '5/8" Plywood Sheathing', weightPerSqFt: 1.6, description: 'Thick roof deck' },
    { name: '5/8" OSB Sheathing', weightPerSqFt: 1.6, description: 'Engineered deck' }
  ]
};

// Helper function to get material by category
export const getMaterialsByCategory = (category) => {
  return buildingMaterialsDatabase[category] || [];
};

// Calculate total weight for a building component
export const calculateComponentWeight = (squareFeet, materials) => {
  let totalWeightPerSqFt = 0;
  
  // Sum up all material weights
  Object.values(materials).forEach(material => {
    if (material && material.weightPerSqFt) {
      totalWeightPerSqFt += material.weightPerSqFt;
    }
  });
  
  const totalPounds = squareFeet * totalWeightPerSqFt;
  const totalTons = totalPounds / 2000;
  
  return {
    squareFeet,
    weightPerSqFt: totalWeightPerSqFt,
    totalPounds,
    totalTons
  };
};
